import { NativeInvoiceAdjustmentSign } from "./nativeInvoiceFormTypes";

export function oppositeNativeInvoiceAdjustmentSign(
    sign: NativeInvoiceAdjustmentSign,
): NativeInvoiceAdjustmentSign {
    return sign === "positive" ? "negative" : "positive";
}

// Form values are labeled: a positive Tax adds, a positive Discount or Deposit
// subtracts. A typed minus flips that default. Snapshot `*Sign` fields are
// derived from this at save — they are not stored on the form.
export function labeledAdjustmentToStored({
    labeledValue,
    defaultSign,
}: {
    labeledValue: number;
    defaultSign: NativeInvoiceAdjustmentSign;
}): { value: number; sign: NativeInvoiceAdjustmentSign } {
    const value = Math.abs(labeledValue);
    if (labeledValue < 0) {
        return {
            value,
            sign: oppositeNativeInvoiceAdjustmentSign(defaultSign),
        };
    }
    return { value, sign: defaultSign };
}

export function storedAdjustmentToLabeled({
    value,
    sign,
    defaultSign,
}: {
    value: number;
    sign: NativeInvoiceAdjustmentSign;
    defaultSign: NativeInvoiceAdjustmentSign;
}): number {
    if (value === 0) {
        return 0;
    }
    return sign === defaultSign ? value : -value;
}
